import { Grid, Typography } from "@mui/material";
import React from "react";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper.tsx";
import FormControlledInputTC from "../../../components/Forms/FormControlledInputTC";
import FormAsyncTC from "../../../components/Forms/FormAsyncTC";
import { useFormContext, useWatch } from "react-hook-form";
import FormSwitchTC from "../../../components/Forms/FormSwitchTC";

function AmountOffTotal() {
  const { menukaartVestigingId } = useFormContext();
  const third_party = useWatch({ name: "third_party" });
  const thirdPartyIsLightspeedK = third_party === "LIGHTSPEEDK";
  return (
    <div style={{ width: "100%", height: "100%" }}>
      <Card>
        <CardBody style={{ padding: 16 }}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Typography variant={"h5"}>
                <TranslationWrapper
                  tDefault={"Amount off of total"}
                  tKey={"voucherDef.amount_off_total.AMOUNT_OFF_TOTAL"}
                />
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography>
                <TranslationWrapper
                  tDefault={"This will give a FIXED AMOUNT discount on the total price of the COMPLETE ORDER."}
                  tKey={"voucherDefs.form.amount_off_total.explanation"}
                />
              </Typography>
            </Grid>

            <FormControlledInputTC
              fieldProps={{ disabled: thirdPartyIsLightspeedK }}
              name={"priceDiscountAmount"}
              tDefault={"Price Discount Amount"}
              tKey={"voucherDefs.form.algemeen.label.priceDiscountAmount"}
              type={"number"}
            />

            <FormAsyncTC
              async={{
                url:
                  "core/producten/search?fields=id as value, naam as label&per_page=250&sort_field=naam&vestiging_id=" +
                  menukaartVestigingId,
                searchField: "naam",
              }}
              key={"freeProducts_JSON" + menukaartVestigingId}
              multiple
              name={"freeProducts_JSON"}
              tDefault={"Voucherproduct (in cash desk / on ticket)"}
              tKey={"voucherDefs.form.algemeen.label.voucherProduct"}
            />
            <FormAsyncTC
              async={{
                url:
                  "core/producten/search?fields=id as value, naam as label&per_page=250&sort_field=naam&vestiging_id=" +
                  menukaartVestigingId,
                searchField: "naam",
              }}
              key={"onlyifProductsInBasket_JSON" + menukaartVestigingId}
              multiple
              name={"onlyifProductsInBasket_JSON"}
              tDefault={"Only allow discount when these products are in Shopping Basket"}
              tKey={"voucherDefs.form.algemeen.label.onlyifProduct"}
            />

            <FormSwitchTC
              name={"allowOnEveryOnlyifProduct"}
              tDefault={"allowOnEveryOnlyifProduct"}
              tKey={"voucherDefs.form.algemeen.label.allowOnEveryOnlyifProduct"}
            />
          </Grid>
        </CardBody>
      </Card>
    </div>
  );
}

export default AmountOffTotal;
